import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import Vs from '@app/services/validators/validators.service';
import { ApplicationService } from '@app/services/application/application.service';
import { TranslateService } from '@ngx-translate/core';
import { formatTableData } from '@app/helpers/tables.helpers';
import { ProcessService } from "../../services/process.service";
import { ApiService } from '../services/api.service';
import { HttpHeaders } from '@angular/common/http';
import { TokenService } from '@app/services/token/token.service';
import { ServiceConfigService } from '@app/services/service-config.service';
import { ActivatedRoute } from '@angular/router';
import { UserProfileService } from '../user-profile/user-profile.service';
import { AuthService } from '../services/auth.service';
import { Router } from "@angular/router";
import { ModalService } from '@app/services/modal/modal.service';
import { toISO } from '@app/helpers/date.helpers';
import { replace } from 'ramda';
import { VerifyIdentityService } from '@app/services/verify-identity.service';
import { SigninService } from "@app/gateway/signin/signin.service";
import { minus120Years } from '@app/helpers/date.helpers';
import { SpinnerService } from '@app/services/spinner/spinner.service';
import { DshService } from '@app/services/dsh.service';
import { GoogleAnalyticsService } from '@app/services/analytics/analytics.service';
declare let gtag: Function;
@Component({
  selector: 'nh-ridp-verify-identity',
  templateUrl: './ridp-verify-identity.component.html',
  styleUrl: './ridp-verify-identity.component.scss',
  standalone: false
})
export class RidpVerifyIdentityComponent implements OnInit, OnDestroy {
  today = new Date();
  minimumDate = minus120Years();
  tableSuffix;
  defaultLanguage;
  translatedLang;
  tablesReady = false
  tcamId;
  fromMobile = false;
  url;
  payLoad = {};
  validSession = false;
  minutes = 0;
  stateDefault = true;
  isDataLoaded = false;
  globalLang;
  disbleVerifyIdentity = false
  timerExpiredFlag = false; // Track if 30-min timer expired
  
  // Banner properties - API driven
  showCantVerifyBanner = false;
  bannerMinutesRemaining = 0;
  ridpTimestamp: string | null = null;
  bannerInterval: any;
  hasScrolledToBanner = false;
  
  tables: { STATE?: any[]; COUNTY?: any[]; RIDPNAMESUFFIX?: any[] } = { STATE: [], COUNTY: [], RIDPNAMESUFFIX: [] };
  ridpVerifyAccount = new FormGroup({
    firstName: new FormControl('', [Vs.fn, Vs.required, Vs.maxLength(32)]),
    middleName: new FormControl('', [Vs.Mn, Vs.maxLength(32)]),
    lastName: new FormControl('', [Vs.ln, Vs.maxLength(32)]),
    suffix: new FormControl(null),
    dateOfBirth: new FormControl('', Vs.validDate),
    ssn: new FormControl('', Vs.ssn),
    phoneNumber: new FormControl('', [Vs.phoneNumber, Vs.required]),
    emailAddress: new FormControl('', [Vs.ridpEmail, Vs.maxLength(63)]),
    ridpConsent: new FormControl('', Vs.required),
    ridpConsent2: new FormControl('', Vs.required),
    ridpAddress: new FormGroup({
      addressLine1: new FormControl(null, [Vs.required, Vs.Sn, Vs.maxLength(40)]),
      addressLine2: new FormControl(null, [Vs.maxLength(19)]),
      city: new FormControl(null, [Vs.required, Vs.Cn, Vs.maxLength(38)]),
      county: new FormControl(null),
      state: new FormControl(null, Vs.required),
      zipCode: new FormControl(null, [Vs.required, Vs.zipCode5Digit]),
      zipExtension: new FormControl(null, [Vs.zipExtension4Digit]),
    }),
  })

  constructor(
    private application: ApplicationService, 
    public translateService: TranslateService, 
    public processService: ProcessService, 
    public apiService: ApiService, 
    public token: TokenService, 
    private serverConfig: ServiceConfigService, 
    private route: ActivatedRoute, 
    private userProfileService: UserProfileService, 
    private authService: AuthService, 
    private router: Router, 
    private modalService: ModalService,
    private verifyIdentityService: VerifyIdentityService,
    public signinService: SigninService,
    private spinner: SpinnerService,
    private dshService: DshService,
    public analytics: GoogleAnalyticsService
  ) {

  }

  onLoadLogic() {
    this.showCantVerifyBanner = sessionStorage.getItem('ridpCantVerifyBanner') && sessionStorage.getItem('ridpTimestamp') ? true : false;
    if(this.showCantVerifyBanner) {
      const timestamp = sessionStorage.getItem('ridpTimestamp')
      this.startBannerCountdown(timestamp);
    }
    if (sessionStorage.getItem('ridpdisplayInvestigatePopuponLoad') === 'true') {
      const userName = sessionStorage.getItem('userName');
      const ridpHubRefNum = sessionStorage.getItem('ridpHubRefNum');
      const isMobileUser = sessionStorage.getItem('isMobileUser') === 'true' ? true : false;
      const currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
      const invIdentityVerify = currentUser?.initialGetRecordCallSw === 'Y';
      this.modalService.openRidpPendingModal(ridpHubRefNum, userName, isMobileUser ? "MOBILE" : "WEB", invIdentityVerify).subscribe();
    } else if ((sessionStorage.getItem('ridpSwitch') === 'ER' || sessionStorage.getItem('ridpSwitch') === 'ND') && sessionStorage.getItem('ridpSubmissionCount') >= '3') {
      this.modalService.openRidpStopModal().subscribe();
    }
  }

  /**
   * Converts date object to MM/dd/yyyy format
   * @param dateObj - Date object with year, monthValue, and dayOfMonth properties OR array [year, month, day]
   * @returns Formatted date string (MM/dd/yyyy)
   */
  private formatDateArray(dateObj: any): string {
    if (!dateObj) {
      return '';
    }
    
    // Handle object format: {year, monthValue, dayOfMonth, ...}
    if (typeof dateObj === 'object' && !Array.isArray(dateObj)) {
      const year = dateObj.year;
      const month = dateObj.monthValue;
      const day = dateObj.dayOfMonth;
      
      if (!year || !month || !day) {
        return '';
      }
      
      const monthStr = month.toString().padStart(2, '0');
      const dayStr = day.toString().padStart(2, '0');
      return `${monthStr}/${dayStr}/${year}`;
    }
    
    // Handle array format: [year, month, day] (legacy support)
    if (Array.isArray(dateObj) && dateObj.length === 3) {
      const [year, month, day] = dateObj;
      const monthStr = month.toString().padStart(2, '0');
      const dayStr = day.toString().padStart(2, '0');
      return `${monthStr}/${dayStr}/${year}`;
    }
    
    return '';
  }

  getTabledCodeValue(table: string, code: string) {
    if (this.tables[table]) {
      const found = this.tables[table].find(item => item.code === code);
      return found ? found : null;
    }
    return null;
  }

  getValueBasedonLanguage(valueObj: any) {
    if (!valueObj) return null;
    return {
          code: valueObj.code,
          value: valueObj.description,
          spValue: valueObj.spDescription
        }
  }

  dataPrefillOnLoad(res) {
    if (res) {
      this.ridpVerifyAccount.controls["firstName"].patchValue(res.firstName);
      this.ridpVerifyAccount.controls["middleName"].patchValue(res.middleName);
      this.ridpVerifyAccount.controls["lastName"].patchValue(res.lastName);
      this.ridpVerifyAccount.controls["suffix"].patchValue(this.getValueBasedonLanguage(this.getTabledCodeValue('RIDPNAMESUFFIX', res.suffixName)));
      this.ridpVerifyAccount.controls["dateOfBirth"].patchValue(this.formatDateArray(res.dobDt));
      this.ridpVerifyAccount.controls["phoneNumber"].patchValue(res.phnNum);
      this.ridpVerifyAccount.controls["emailAddress"].patchValue(res.emailAddr);
      this.ridpVerifyAccount.controls["ssn"].patchValue(res.ssnNum);
      if(sessionStorage.getItem('ridpSwitch') === 'ER' || sessionStorage.getItem('ridpSwitch') === 'ND'){
      this.ridpVerifyAccount.controls["ridpConsent"].patchValue(null);
      this.ridpVerifyAccount.controls["ridpConsent2"].patchValue(null);
      } else {
      this.ridpVerifyAccount.controls["ridpConsent"].patchValue(res.memberConsentSw);
      this.ridpVerifyAccount.controls["ridpConsent2"].patchValue(res.ridpDataSourceConsentSw);
      }   
      this.ridpVerifyAccount.controls["ridpAddress"].controls["addressLine1"].patchValue(res.addrLine1);
      this.ridpVerifyAccount.controls["ridpAddress"].controls["addressLine2"].patchValue(res.addrLine2);
      this.ridpVerifyAccount.controls["ridpAddress"].controls["city"].patchValue(res.cityAddr);
      if(res.stateCd === 'TN'){
        this.stateDefault = true
      } else {
        this.stateDefault = false
      }
      this.ridpVerifyAccount.controls["ridpAddress"].controls["state"].patchValue(this.getTabledCodeValue('STATE', res.stateCd));
      if(res.county !== 'US'){
      this.ridpVerifyAccount.controls["ridpAddress"].controls["county"].patchValue(this.getTabledCodeValue('COUNTY', res.addrCountyCd));
      }
      this.ridpVerifyAccount.controls["ridpAddress"].controls["zipCode"].patchValue(res.zipCd);
      this.ridpVerifyAccount.controls["ridpAddress"].controls["zipExtension"].patchValue(res.zipCdExt);
      
      // Start loading DSH when data is pre-filled (user might click Next quickly)
      this.loadDHS();
    }
  }

  ngOnInit() {
    this.globalLang = sessionStorage.getItem('globalTranslatedLan');
    this.tcamId = this.serverConfig.getServerConfig().TCAM_KEY;
    const params = this.route.snapshot.queryParams
    if (Object.keys(params).length > 0) {  //logic for mobile users for both valid and invalid sessions
      this.route.queryParams.subscribe((response: any) => {
        if (response?.mpToken) {
          this.fromMobile = response?.fromMobile === 'true' ? true : false;
          this.url = this.fromMobile ? `publ/users/mobileUserLogin` : null;
          const source = this.fromMobile === true ? 'mobile' : null;
          const defaultLang = response.lang ? response.lang : "en";
          if (defaultLang && this.fromMobile) {
            this.translateService.setDefaultLang(defaultLang);
          }
          this.payLoad = { tcam: this.token.getCookie(this.tcamId), mpToken: response?.mpToken, source: source };
          this.apiService.removeQueryParam('mpToken');
          this.apiService.removeQueryParam('fromMobile');
          this.apiService.removeQueryParam('lang');
        }
      })
      // need to confirm page id
      const contentHeader = new HttpHeaders({ "Content-Type": "application/json", pageId: 'TCKPR', 'sessionId': this.token.getSessionId() });

      this.apiService.post(this.url, this.payLoad, { headers: contentHeader, observe: 'response' }).subscribe((response: any) => {
        if (response && response.body?.isValidSession === 'true' && this.fromMobile) {   // if mobile session is valid
          sessionStorage.setItem('isMobileUser', 'true')
          this.userProfileService.fromMobileApptoTcc(this.fromMobile);   //check if this is needed
          const authToken = response.headers.get('x-auth-token');
          sessionStorage.setItem('userType', response.body?.userType);
          sessionStorage.setItem('userName', response.body?.userName);
          sessionStorage.setItem('individualId', response.body?.indvId);
          sessionStorage.setItem('encryptedIndvId', response.body?.encryptedIndvId);
          this.authService.setToken(authToken);
          this.validSession = true;
          const userName = sessionStorage.getItem('userName');
          this.analytics.setCurrentUser(userName);
          this.signinService.getAccountData(userName).subscribe((data: any) => {
            if (data) {
              sessionStorage.setItem('currentUser', JSON.stringify(data));
              sessionStorage.setItem('individualId', data['indvId']);
              sessionStorage.setItem('firstTimeAccessSw', data['firstTimeAccessSw']);
              sessionStorage.setItem('ridpSwitch', data['ridpverfStatusCd']);
              data['ridpverfStatusTimeStamp'] ? sessionStorage.setItem('ridpTimestamp', data['ridpverfStatusTimeStamp']) : null;
              data['ridpHubrefNum'] ? sessionStorage.setItem('ridpHubRefNum', data['ridpHubrefNum']) : null;
              data['ridpDocVerfSw'] ? sessionStorage.setItem('documentStatus', data['ridpDocVerfSw']) : null;
              data['rIDPSubmissionCounter'] ? sessionStorage.setItem('ridpSubmissionCount', data['rIDPSubmissionCounter']) : null;
              this.verifyIdentityButtonSwitch(data);
              sessionStorage.getItem('ridpSwitch') === 'ER' || sessionStorage.getItem('ridpSwitch') === 'ND' ? sessionStorage.setItem('ridpCantVerifyBanner', 'true') : null;
              const verifyIdentityInvestigate = sessionStorage.getItem('ridpSwitch') === 'IV';
              const verifyIdentityStop = sessionStorage.getItem('ridpSwitch') === 'ST';
              if (verifyIdentityInvestigate) {
                sessionStorage.setItem('ridpdisplayInvestigatePopuponLoad', 'true');
                this.onLoadLogic()
              } else if (verifyIdentityStop && sessionStorage.getItem('documentStatus') === 'ERR') {
                sessionStorage.setItem('ridpNotVerified', 'true')
                sessionStorage.setItem('ridpReviewDocs', 'true')
                this.router.navigateByUrl("/verify-identity/uploadDocuments");
              } else if (verifyIdentityStop && sessionStorage.getItem('documentStatus') === 'IP') {
                sessionStorage.setItem('ridpReviewDocs', 'true')
                this.router.navigateByUrl("/verify-identity/uploadDocuments");
              } else if (verifyIdentityStop && (!sessionStorage.getItem('documentStatus') || sessionStorage.getItem('documentStatus') === 'null')) {
                this.router.navigateByUrl("/verify-identity/uploadDocuments");
              } else if(sessionStorage.getItem('ridpTimestamp')){
                 this.onLoadLogic()
              }
            }
          });
          this.application.getTables(['STATE', 'COUNTY', 'RIDPNAMESUFFIX']).subscribe({
            next: (res:any) => {
              this.tables['STATE'] = res['referenceGroup'][0].referenceData ?? [];
              this.tables['COUNTY'] = res['referenceGroup'][1].referenceData ?? [];
              this.tables['RIDPNAMESUFFIX'] = res['referenceGroup'][2].referenceData ?? [];
              this.tablesReady = true;
              this.setupLanguageHandling();
              this.processNameSuffix();
              
              // Call getRidpUserDetails after tables are loaded
              const ridpSubmissionCount = sessionStorage.getItem('ridpSubmissionCount');
               const fromErrorReload = sessionStorage.getItem('ridpErrorReload');
              if ((ridpSubmissionCount && Number(ridpSubmissionCount) > 0) && !fromErrorReload) {
                const userId = sessionStorage.getItem('userName');
                this.apiService.get(`indi/users/getRidpUserDetails?userId=${userId}`, null, {
                  headers: new HttpHeaders({ 'pageId': 'RIDPAHS', 'sessionId': this.token.getSessionId() })
                }).subscribe((response: any) => {
                  this.stateDefault = !response?.stateCd || response?.stateCd === 'TN';
                  this.dataPrefillOnLoad(response);
                  this.isDataLoaded = true;
                });
              } else {
                this.isDataLoaded = true;
              }
              // Retry DSH if page-load initialization failed (transient Experian service issue).
              if (!this.dshService.hasValues()) {
                this.dshService.retryInitialization();
              }
              this.loadDHS();
            },
          });
        } else if (response && response.body?.isValidSession === 'false' && this.fromMobile) {    // if mobile session is not valid - confirm the implementation
          this.validSession = false;
          sessionStorage.setItem('isMobileUser', 'true')
          this.userProfileService.fromMobileApptoTcc(this.fromMobile);
          this.router.navigateByUrl('/invalidSession');
        }
      });
    } else {  // for regular users
    this.onLoadLogic()
      this.application.getTables(['STATE', 'COUNTY', 'RIDPNAMESUFFIX']).subscribe({
        next: (res:any) => {
          this.tables['STATE'] = res['referenceGroup'][0].referenceData ?? [];
          this.tables['COUNTY'] = res['referenceGroup'][1].referenceData ?? [];
          this.tables['RIDPNAMESUFFIX'] = res['referenceGroup'][2].referenceData ?? [];
          this.tablesReady = true;
          this.setupLanguageHandling();
          this.processNameSuffix();
          
          // Call getRidpUserDetails after tables are loaded
          const ridpSubmissionCount = sessionStorage.getItem('ridpSubmissionCount');
          const fromErrorReload = sessionStorage.getItem('ridpErrorReload');
          const ridpSwitch = sessionStorage.getItem('ridpSwitch');
          if (ridpSwitch && ridpSwitch !== 'null' && ridpSwitch !== "PE") {
            if (ridpSwitch === 'IV' || ridpSwitch === 'ST' || ridpSwitch === 'SS') {
              this.disbleVerifyIdentity = true;
            } else {
              this.disbleVerifyIdentity = false;
            }
          } else {
            this.disbleVerifyIdentity = false;
          }
          if ((ridpSubmissionCount && Number(ridpSubmissionCount) > 0) && !fromErrorReload) {
            const userId = sessionStorage.getItem('userName');
            this.apiService.get(`indi/users/getRidpUserDetails?userId=${userId}`, null, {
              headers: new HttpHeaders({ 'pageId': 'RIDPAHS', 'sessionId': this.token.getSessionId() })
            }).subscribe((response: any) => {
              this.stateDefault = !response?.stateCd || response?.stateCd === 'TN';
              this.dataPrefillOnLoad(response);
              this.isDataLoaded = true;
            });
          } else {
            this.isDataLoaded = true;
          }
          // Retry DSH if page-load initialization failed (transient Experian service issue).
          if (!this.dshService.hasValues()) {
            this.dshService.retryInitialization();
          }
          this.loadDHS();
        },
      });
    }
  }

  private async loadDHS(maxAttempts = 60): Promise<boolean> {
    return await this.dshService.loadDSH(maxAttempts);
  }

  displayCantVerifyBanner() {
     this.showCantVerifyBanner = sessionStorage.getItem('ridpCantVerifyBanner') && sessionStorage.getItem('ridpTimestamp') ? true : false;
     if(this.showCantVerifyBanner && !this.hasScrolledToBanner) {
              setTimeout(() => {
          const container = document.querySelector('.mat-sidenav-content') as HTMLElement;
          if (container) {
            container.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
            this.hasScrolledToBanner = true;
          }
        }, 100)
     }
     return  this.showCantVerifyBanner
  }

  private calculateMinutesRemaining(timestamp: string): number {
    if (!timestamp) return 0;
    
    try {
      const submittedTime = new Date(timestamp).getTime();
      const currentTime = Date.now();
      const elapsedMinutes = Math.floor((currentTime - submittedTime) / (1000 * 60));
      const remainingMinutes = Math.max(0, 29 - elapsedMinutes);
      
      return remainingMinutes;
    } catch (error) {
      console.error('Error calculating minutes remaining:', error);
      return 0;
    }
  }

  private startBannerCountdown(timestamp: string) {
    this.ridpTimestamp = timestamp;
    this.bannerMinutesRemaining = this.calculateMinutesRemaining(timestamp);
    this.minutes = this.bannerMinutesRemaining; // Sync minutes with remaining time
    
    // If time has already expired, don't show banner
    if (this.bannerMinutesRemaining <= 0) {
      this.stopBannerCountdown();
      return;
    }
    
    if (this.bannerMinutesRemaining > 0) {
      sessionStorage.setItem('ridpCantVerifyBanner', 'true');
      sessionStorage.setItem('ridpTimestamp', timestamp)
      this.showCantVerifyBanner = true;
      
      // Update every minute
      this.bannerInterval = setInterval(() => {
        this.bannerMinutesRemaining = this.calculateMinutesRemaining(this.ridpTimestamp!);
        this.minutes = this.bannerMinutesRemaining; // Update minutes property
        
        if (this.bannerMinutesRemaining <= 0) {
          this.stopBannerCountdown();
        }
      }, 60000); // Update every minute
    }
  }

  private stopBannerCountdown() {
    this.showCantVerifyBanner = false;
    sessionStorage.removeItem('ridpCantVerifyBanner');
    sessionStorage.removeItem('ridpTimestamp')
    this.ridpTimestamp = null;
    this.minutes = 0; // Reset minutes when countdown stops
    this.hasScrolledToBanner = false; // Reset scroll flag
    this.disbleVerifyIdentity = false;
    // Mark that timer has expired (enables re-submission tracking)
    this.timerExpiredFlag = true;
    if (this.bannerInterval) {
      clearInterval(this.bannerInterval);
      this.bannerInterval = null;
    }
  }

  checkSSNAlertMessageDIssplay() {
    return (this.ridpVerifyAccount.get('ssn').touched && this.ridpVerifyAccount.get('ssn').value === '') || (this.ridpVerifyAccount.get('ssn').value === '' && this.ridpVerifyAccount.get('ridpAddress.addressLine1').value !== null);
  }

  deselect(val) {
    if (val.target.checked) {
      this.ridpVerifyAccount.controls["ridpConsent"].patchValue('Y');
    } else {
      this.ridpVerifyAccount.controls["ridpConsent"].patchValue(null);
    }
  }

  deselectTwo(val) {
    if (val.target.checked) {
      this.ridpVerifyAccount.controls["ridpConsent2"].patchValue('Y');
    } else {
      this.ridpVerifyAccount.controls["ridpConsent2"].patchValue(null);
    }
  }

  processNameSuffix() {
    const tableData = this.tables.RIDPNAMESUFFIX ? this.tables.RIDPNAMESUFFIX.map(name => {
      return {
        code: name.code,
        rank: name.rank,
        value: name.description,
        spValue: name.spDescription
      }
    }) : [];
    const tableSuffixVal = tableData.sort((a, b) => (Number(a.rank) > Number(b.rank) ? 1 : -1));

    if (tableSuffixVal) {
      this.tableSuffix = tableSuffixVal.map(name => {
        return {
          code: name.code,
          value: name.value,
          spValue: name.spValue
        }
      });
    }
  }

  setupLanguageHandling() {
    this.defaultLanguage = this.translateService.getDefaultLang();
    this.languageCheck(this.defaultLanguage);
    this.translatedLang = this.defaultLanguage;
    this.translateService.onDefaultLangChange.subscribe((res) => {
      this.translatedLang = res.lang;
      this.languageCheck(res.lang);
    });
  }

  languageCheck(language) {
    this.tables = language === 'sp' ? formatTableData(this.tables, 'spDescription') : formatTableData(this.tables, 'description');
  }

  isFormValid(): boolean {
    return this.ridpVerifyAccount.status === "VALID";
  }

  async onNext(): Promise<void> {
    if (!this.dshService.hasValues()) {
      // Re-attempt HDIM/JSC. retryInitialization() self-guards: it skips if values already
      // exist or a request is still in flight, and otherwise fires a fresh xp() call.
      this.dshService.retryInitialization();
      this.spinner.increment();
      await this.loadDHS(30);
      this.spinner.decrement();
    }
    this.addressValidation();
  }

  /**
   * Extracts zip code and extension from formatted zip string
   * Handles formats: "12345", "12345-6789", or "123456789"
   * @param zip - Zip code (format: XXXXX or XXXXX-XXXX or XXXXXXXXX)
   * @returns Object with zipCode and extension
   */
  private extractZipCodeParts(zip: string): { zipCode: string; extension: string } {
    if (!zip) {
      return { zipCode: '', extension: '' };
    }

    // Remove all non-digit characters
    const digitsOnly = zip.replace(/\D/g, '');

    // If 9 digits, split into 5+4
    if (digitsOnly.length === 9) {
      return {
        zipCode: digitsOnly.substring(0, 5),
        extension: digitsOnly.substring(5, 9)
      };
    }

    // If more than 5 digits but not 9, try to split at position 5
    if (digitsOnly.length > 5) {
      return {
        zipCode: digitsOnly.substring(0, 5),
        extension: digitsOnly.substring(5)
      };
    }

    // Otherwise, just return the digits as zipCode
    return {
      zipCode: digitsOnly,
      extension: ''
    };
  }

  /**
   * Formats date for API (YYYY-MM-DD)
   * Uses existing toISO helper from date.helpers.ts
   * @param date - Date string from form (MM/DD/YYYY or YYYY-MM-DD)
   * @returns Formatted date string (YYYY-MM-DD) or empty string if invalid
   */
  private formatDateForAPI(date: string): string {
    if (!date) return '';

    // If date is already in YYYY-MM-DD format, return as is
    if (/^\d{4}-\d{2}-\d{2}$/.test(date)) {
      return date;
    }

    // If date is in MM/DD/YYYY format, convert using toISO
    if (/^\d{2}\/\d{2}\/\d{4}$/.test(date)) {
      try {
        // Parse MM/DD/YYYY to Date object, then convert to ISO format
        const [month, day, year] = date.split('/');
        const dateObj = new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
        return toISO(dateObj);
      } catch (error) {
        console.error('Date formatting error:', error);
        return '';
      }
    }

    // If format is unrecognized, try to parse as Date and convert to ISO
    try {
      const dateObj = new Date(date);
      if (!isNaN(dateObj.getTime())) {
        return toISO(dateObj);
      }
    } catch (error) {
      console.error('Date parsing error:', error);
    }

    // Return empty string if unable to format to YYYY-MM-DD
    return '';
  }

  /**
   * Formats phone number to digits only
   * Uses Ramda's replace for removing non-digit characters
   * @param phone - Phone number string
   * @returns Phone number with only digits
   */
  private formatPhoneNumber(phone: string): string {
    if (!phone) return '';
    return replace(/\D/g, '', phone);
  }

  /**
   * Formats SSN to digits only
   * Uses Ramda's replace for removing non-digit characters
   * @param ssn - SSN string
   * @returns SSN with only digits
   */
  private formatSSN(ssn: string): string {
    if (!ssn) return '';
    return replace(/\D/g, '', ssn);
  }

  addressValidation(): void {
    const addressValue = this.ridpVerifyAccount.get('ridpAddress')?.value;
    const combinedZip = addressValue.zipExtension 
      ? `${addressValue.zipCode}${addressValue.zipExtension}` 
      : addressValue.zipCode;
    
    const addressToValidate = {
      addressLine1: addressValue.addressLine1,
      addressLine2: addressValue.addressLine2,
      city: addressValue.city,
      state: addressValue.state,
      zip: combinedZip,
      county: addressValue?.county
    };

    const postObject = {
      addressList: [
        { addressType: 'PHYSICAL', originalAddress: addressToValidate }
      ]
    };
    
    this.verifyIdentityService.validateAddress(postObject).subscribe({
      next: (res) => {
        if (res) {
          // Show modal with isRidpFlow flag set to true
          this.modalService.openAddressModal(res, null, true).subscribe(result => {            
            if (result === true) {
              return;
            }
            
            if (result && Array.isArray(result)) {
              const phyIndex = result.findIndex(i => i.addressType === 'PHYSICAL');
              
              if (phyIndex >= 0) {
                const addressData = result[phyIndex];
                const ridpAddressGroup = this.ridpVerifyAccount.get('ridpAddress');
                
                if (ridpAddressGroup) {
                  // Preserve the existing county value since API doesn't return it
                  const currentCounty = ridpAddressGroup.get('county')?.value;
                  
                  // Update form with selected address
                  if (addressData.selectedAddress === 'Suggested') {
                    const selectedState = this.tables.STATE.find(s => s.code === addressData.suggestedAddress.state.code);
                    const zipParts = this.extractZipCodeParts(addressData.suggestedAddress.zip);
                    ridpAddressGroup.patchValue({
                      addressLine1: addressData.suggestedAddress.addressLine1,
                      addressLine2: addressData.suggestedAddress.addressLine2 || '',
                      city: addressData.suggestedAddress.city,
                      state: selectedState || null,
                      zipCode: zipParts.zipCode,
                      zipExtension: zipParts.extension,
                      county: currentCounty
                    });
                  } else if (addressData.selectedAddress === 'Original') {
                    const selectedState = this.tables.STATE.find(s => s.code === addressData.originalAddress.state.code);
                    const zipParts = this.extractZipCodeParts(addressData.originalAddress.zip);
                    ridpAddressGroup.patchValue({
                      addressLine1: addressData.originalAddress.addressLine1,
                      addressLine2: addressData.originalAddress.addressLine2 || '',
                      city: addressData.originalAddress.city,
                      state: selectedState || null,
                      zipCode: zipParts.zipCode,
                      zipExtension: zipParts.extension,
                      county: currentCounty
                    });
                  }
                }
              }
              // After updating address, call RIDP API
              this.callRidpApi();
            }
          }, (error) => {
            console.error('Address validation modal error:', error);
          });
        } else {
          console.log('No address validation response');
        }
      },
      error: (error) => {
        console.error('Address validation API error:', error);
      }
    });
  }

  private async callRidpApi(): Promise<void> {
    // Track if user is resubmitting after 30-minute timer expired
    if (this.timerExpiredFlag) {
      gtag('event', 'ridp_resubmit_after_timer', {
        'event_category': 'ridp_identity_verification',
        'event_label': 'user_resubmitted_after_30min_timer',
        'submission_count': sessionStorage.getItem('ridpSubmissionCount') || '0'
      });
      this.timerExpiredFlag = false;
    }

    // If DSH values are missing, do a last-chance retry before proceeding.
    // onNext() already decremented its spinner, so incrementing here is safe.
    if (!this.dshService.hasValues()) {
      this.dshService.retryInitialization();
      this.spinner.increment();
      await this.loadDHS();
      this.spinner.decrement();
    }

    const formValue = this.ridpVerifyAccount.value;
    const addressValue = formValue.ridpAddress;
    const userName = sessionStorage.getItem('userName');
    const dshValues = this.dshService.getValues();

    const payload = {
      "usrId": userName,
      "addrCountyCd": addressValue.county?.code || "US",
      "firstName": formValue.firstName?.trim() || '',
      "lastName": formValue.lastName?.trim() || '',
      "middleName": formValue.middleName?.trim() || '',
      "suffixName": formValue.suffix?.code || '',
      "dobDt": this.formatDateForAPI(formValue.dateOfBirth),
      "addrLine1": addressValue.addressLine1?.trim() || '',
      "addrLine2": addressValue.addressLine2?.trim() || '',
      "cityAddr": addressValue.city?.trim() || '',
      "stateCd": addressValue.state?.code || '',
      "zipCd": addressValue.zipCode || '',
      "zipCdExt": addressValue.zipExtension || '',
      "phnNum": this.formatPhoneNumber(formValue.phoneNumber),
      "emailAddr": formValue.emailAddress?.trim() || '',
      "ssnNum": this.formatSSN(formValue.ssn),
      "ridpSourceCd": this.fromMobile ? "MOBILE" : "WEB",
      "jsc": dshValues?.jsc,
      "hdimValue": dshValues?.hdim,
      "memberConsentSw": formValue.ridpConsent  ? 'Y' : 'N',
      "ridpDataSourceConsentSw": formValue.ridpConsent2 ? 'Y' : 'N',
      "langCd": this.translatedLang === 'en' ? 'EN' : 'ES'
    };
    if (!this.dshService.hasValues()) {
      gtag('event', 'hdim_service_error', {
        'event_category': 'ridp_identity_verification',
        'event_label': 'missing_jsc_or_hdim'
      });
      console.error('[DSH] jsc/hdimValue could not be loaded. Possible ad blocker or Experian service unavailable.');
    }

    // Call RIDP API
    this.verifyIdentityService.verifyIdentity(payload).subscribe({
      next: (data: any) => {
        const successCodes = ['HS000000', 'HX005001', 'HE200024', 'HX009000', 'HE200027']
        if (data?.rbaRIDPResponse?.idProofedResponse && successCodes.includes(data?.rbaRIDPResponse?.responseMetadata?.responseCode)) {
          const finalDecision = data?.rbaRIDPResponse?.idProofedResponse?.finalDecisionCode?.toUpperCase();
          const hubReferenceNumber = data?.rbaRIDPResponse?.idProofedResponse?.hubReferenceNumber;
          const timestamp = data?.rbaRIDPResponse?.ridpSubmittedTs;
          this.signinService.getAccountData(userName).subscribe((res: any) => {
            res['rIDPSubmissionCounter'] ? sessionStorage.setItem('ridpSubmissionCount',res['rIDPSubmissionCounter']): null;
            this.verifyIdentityButtonSwitch(res);
          if (finalDecision === 'CONTINUE') {
            this.modalService.openRidpSuccessModal().subscribe();
          } else if (finalDecision === 'INVESTIGAT') {
            this.modalService.openRidpPendingModal(hubReferenceNumber, userName, this.fromMobile ? "MOBILE" : "WEB").subscribe();
          } else if (finalDecision === 'STOP') {
            this.modalService.openRidpStopModal().subscribe();
          } else if (finalDecision === 'ERROR' || finalDecision === 'NODECISION') {
           // make the info the callRidpApi, check for the counter and then proceed.
           
            if(res && res.ridpverfStatusCd && res.ridpverfStatusCd === 'ST' && res.rIDPSubmissionCounter >= 3) {
            this.modalService.openRidpStopModal().subscribe();
            } else {
              // Start banner countdown using timestamp from API
               if (timestamp) {
              this.startBannerCountdown(timestamp);
            }
            this.modalService.openRidpErrorModal().subscribe();
            }
          
          }
        })
        } else if(!data?.rbaRIDPResponse?.idProofedResponse || !successCodes.includes(data?.rbaRIDPResponse?.responseMetadata?.responseCode)) {
           this.modalService.openRidpServiceDownModal().subscribe();
        }
      },
      error: (error) => console.error('RIDP API error:', error)
    });
  }
  
  verifyIdentityButtonSwitch(res) {
    sessionStorage.setItem('ridpSwitch', res['ridpverfStatusCd']);
    const ridpSwitch = sessionStorage.getItem('ridpSwitch');
    if (ridpSwitch && ridpSwitch !== 'null' && ridpSwitch !== "PE") {
      if (ridpSwitch === 'IV' || ridpSwitch === 'ST' || ridpSwitch === 'SS') {
        this.disbleVerifyIdentity = true;
      } else {
        this.disbleVerifyIdentity = false;
      }
    } else {
      this.disbleVerifyIdentity = false;
    }
  }

  ngOnDestroy() {
    if (this.bannerInterval) clearInterval(this.bannerInterval);
  }

  decreaseFont(){
    const globalLang = sessionStorage.getItem('globalTranslatedLan'); 
    return globalLang === 'de' || globalLang === 'vi' || globalLang === 'ru';
  }

  decreaseFontExtra(){
    const globalLang = sessionStorage.getItem('globalTranslatedLan'); 
    return globalLang === 'tl';
  }
}
